import { render, staticRenderFns } from "./ResetPasswordDetail.vue?vue&type=template&id=c1b382d8&scoped=true&"
import script from "./ResetPasswordDetail.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordDetail.vue?vue&type=style&index=0&id=c1b382d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b382d8",
  null
  
)

export default component.exports